module.exports = __webpack_public_path__ + "static/media/irregation_works_header_with_windvain.0037d05e.png";